import { useMemo } from 'react';

import { type TColumnsSectionBlock } from '.';
import { columnsCountParser, columnsGapParser, parseColumnGridDimensions } from './parsers';

export default function useBlockProps(block: TColumnsSectionBlock) {
  return useMemo(() => {
    const columnsCount = columnsCountParser.parse(block.props?.columnsCount) as 2 | 3;
    return {
      columnsCount,
      columnGridDimensions: parseColumnGridDimensions(columnsCount, block.props?.columnGridDimensions),
      blocks: block.props?.blocks ?? [null, null, null],
      fixedWidths: block.props?.fixedWidths ?? [null, null, null],
      columnGap: columnsGapParser.parse(block.props?.columnGap),
      contentAlignment: block.props?.contentAlignment ?? 'middle',
      dimensionsRule: block.props?.dimensionsRule ?? 'percentage',
      mobileLayout: block.props?.mobileLayout ?? 'columns',
    } as const;
  }, [block]);
}
